import React, { Component } from 'react';
import Loader from '../../container/Loader';
import { Form } from 'reactstrap';
import Swal from 'sweetalert2';
import MaskedInput from 'react-maskedinput';
import { getId, NAME_USER, ACCESS_USER, getToken, getAccessUser } from "../../services/auth";
import api from "../../services/api";
import mail from "../../services/mail";
import ApiCep from "../../services/cep";
import Email from "../Email";
import { renderEmail } from 'react-html-email'


class FormUser extends Component {

    constructor(props) {
        super(props)
        this.state = { 
          loading: true,
          errors: {},
          id: 0,
          nome: '',
          cpf_cnpj: '',
          tipo_doc: '',
          documento: '',
          telefone: '',
          celular: '',
          email: '',
          senha: '',
          conf_senha: '',
          env_senha: '',
          id_tipo: '',
          cep: '',
          tipo_logradouro: '',
          logradouro: '',
          numero: '',
          complemento: '',
          bairro: '',
          cidade: '',
          uf: ''            
       }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
      }

  getCep(e) {
    const cep = e.target.value;
    ApiCep.SearchCep(cep)
      .then(res => {
        let logradouro = res.data.logradouro;
        let bairro = res.data.bairro;
        let cidade = res.data.localidade;
        let uf = res.data.uf;

        this.setState({ logradouro: logradouro, bairro: bairro, cidade: cidade, uf: uf })
      }).catch(err => console.log(err));
  }

  Email(email, password) {

    let conteudo = '';
    let subject = '';

    subject = 'Bem vindo ao Dommus - Cadastro do Usuário';
    conteudo = renderEmail(<Email email={email} password={password}/>);

    mail.post('vendaonline/dommus-mail',
    {
      email: email,
      subject: subject,
      conteudo: conteudo
      
    })
    .then((response) => {
      console.log(response)
    }).catch((error) => {
      console.log(error)
    });    
  }

  handleChange(e){
    const target = e.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  componentDidMount() {
    const id  = getId();
    const token = getToken();

    api.get('usuario/' + id, {
      headers: { token },
    })
    .then(response => {
      const { nome, email, telefone, celular, cpf_cnpj, tipo_doc, numero_doc, id_tipo, cep, tipo, logradouro, numero, complemento, bairro, cidade, uf } = response.data;
      this.setState({ id, nome, email, telefone, tipo_doc, documento: numero_doc, celular, cpf_cnpj, id_tipo, cep, tipo_logradouro: tipo, logradouro, numero, complemento, bairro, cidade, uf, loading: false});
    })
    .catch(function (error) {
      console.log(error);
    })   
  }

  handleSubmit(e) {
    e.preventDefault();
    if(this.validate()){
      const token = getToken();
    api.post('usuario', 
    {
      id: this.state.id, 
      email: this.state.email, 
      nome: this.state.nome, 
      telefone: this.state.telefone, 
      celular: this.state.celular, 
      tipo_doc: this.state.tipo_doc, 
      numero_doc: this.state.documento, 
      cpf_cnpj: this.state.cpf_cnpj,
      cep: this.state.cep,
      password: this.state.senha,
      tipo: this.state.tipo_logradouro,
      logradouro: this.state.logradouro,
      numero: this.state.numero,
      complemento: this.state.complemento,
      bairro: this.state.bairro,
      cidade: this.state.cidade,
      uf: this.state.uf,
      id_tipo: this.state.id_tipo,
      id_logado: getId() 
    },
    { headers: { token }} )
    .then((response) => {
      if(this.state.env_senha){
        this.Email(this.state.email, this.state.password);
      }
      Swal.fire({
        title: response.data.success ? 'Usuário cadastrado com sucesso' : 'Ocorreu um erro ao salvar, tente novamente.',
        icon: response.data.success ? 'success': 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK',
      }).then((result) => {
        if (result.value) {
          localStorage.setItem(NAME_USER, this.state.nome);
          localStorage.setItem(ACCESS_USER, false);
          window.location.reload();
        }
    })
      
    });    
    }  
  }

  validate(){
    let senha = this.state.senha;
    let conf_senha = this.state.conf_senha;

    let email = this.state.email;
    let nome = this.state.nome;

    let errors = {};
    let isValid = true;
    
    if (!nome) {
      isValid = false;
      errors["nome"] = "Por favor, insira seu nome.";
    }
        
    if (email === nome) {
      isValid = false;
      errors["nome"] = "Não pode colocar email do Nome, você pode alterar o seu nome.";
    }
    
    if (!senha) {
      isValid = false;
      errors["password"] = "Por favor, insira sua senha.";
    }

    if (!conf_senha) {
      isValid = false;
      errors["confirm_password"] = "Por favor, digite sua senha de confirmação.";
    }

    if (typeof senha !== "undefined" && typeof conf_senha !== "undefined") {
        
      if (senha !== conf_senha) {
        isValid = false;
        errors["password"] = "As senhas não correspondem.";
      }
    } 

    this.setState({
      errors: errors
    });

    return isValid;
}

  render() {
    const isLoggedIn = this.state.loading;
    let closeBtn = '';
    if (!JSON.parse(getAccessUser())) {
      closeBtn = <button type="button" className="btn btn-danger" onClick={this.props.toggle} data-dismiss="modal">Fechar</button>
    }

    return (
      <Form style={{ marginBottom: isLoggedIn ? '100px' : ''}} onSubmit={this.handleSubmit}>
        {isLoggedIn ? <Loader /> : 
        <div className="tab-pane fade pt-3 active show" id="cadastro" role="tabpanel" aria-labelledby="cadastro">
          <div className="cadastro-usuario-wrapper">
            <header >
              Cadastro do Usuário
            </header>
            <div className="cadastro-wrapper" style={{ backgroundColor: 'white' }}>
              <header >
                Dados do Usuário
              </header>
              <div className="dados-wrapper" >
                <div className="row">
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="nome" className="labelB">Email <span style={{ color: 'red' }}>*</span></label>
                      <input type="text" name="email" disabled defaultValue={this.state.email === null ? "" : this.state.email }
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="nome" className="labelB">Nome <span style={{ color: 'red' }}>*</span></label>
                      <input type="text" name="nome" defaultValue={this.state.nome === null ? "" : this.state.nome}
                        className="form-control"
                        placeholder="Nome"
                        onChange={this.handleChange.bind(this)} required
                      />
                      <small className="form-text text-danger">{this.state.errors.nome}</small>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="cpf_cnpj" className="labelB">CPF <span style={{ color: 'red' }}>*</span></label>
                      <MaskedInput mask="111.111.111-11" type="text" name="cpf_cnpj" maxLength='14' value={this.state.cpf_cnpj === null ? '' : this.state.cpf_cnpj}
                        className="form-control"
                        placeholder="CPF"
                        onChange={this.handleChange.bind(this)} required
                      />
                      <small className="form-text text-danger"></small>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="tipo_doc" className="labelB">Tipo Doc.</label>
                      <select className="form-control custom-select" onChange={this.handleChange.bind(this)}
                        name="tipo_doc" value={this.state.tipo_doc === null ? '' : this.state.tipo_doc} required>
                        <option value="" >Selecione</option>
                        <option value="RG">Carteira de Identidade - RG</option>
                        <option value="CTPS">Carteirade Trabalho e Previdência Social - CTPS</option>
                        <option value="CO/CC">Carteira de Órgão ou Conselho de Classe (OAB, CRECI,CREA, ...)</option>
                        <option value="CM">Certificado Militar</option>
                        <option value="CNH">Carteira Nacional de Habilitação - CNH</option>
                        <option value="P">Passaporte</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="documento" className="labelB">Nº Documento:</label>
                      <input type="text" name="documento" defaultValue={this.state.documento === null ? '' : this.state.documento}
                        className="form-control"
                        placeholder="Nº Documento" 
                        onChange={this.handleChange.bind(this)} required
                        />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="telefone1" className="labelB">Telefone Fixo:</label>
                      <MaskedInput mask="(11) 11111-1111" type="text" name="telefone" value={this.state.telefone === null ? '' : this.state.telefone}
                        className="form-control"
                        placeholder="Telefone" 
                        onChange={this.handleChange.bind(this)} required
                        />                        
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="celular" className="labelB">Celular:</label>
                      <MaskedInput mask="(11) 11111-1111" type="text" name="celular" value={this.state.celular === null ? '' : this.state.celular}
                        className="form-control"
                        placeholder="Celular"
                        onChange={this.handleChange.bind(this)} required
                      />
                      <small className="form-text text-danger"></small>
                    </div>
                  </div>
                </div>
              </div>
              <header>
                Dados de Autenticação
            </header>
              <div className="autenticacao-wrapper" >
                <div className="row">
                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="senha" className="labelB">Senha</label>
                      <div className="input-group">
                        <input type="text" name="senha" className="form-control" onChange={this.handleChange.bind(this)}/>
                        <div className="input-group-append">
                          <button type="button" className="btn btn-dommus-action" data-toggle="tooltip"
                            data-trigger="hover" title="" data-placement="bottom"
                            data-original-title="Gerar Senha">
                            <i className="fa fa-key" aria-hidden="true"></i></button>
                        </div>
                      </div>
                      <small className="form-text text-danger">{this.state.errors.password}</small>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="conf_senha" className="labelB">Confirmação de Senha</label>
                      <input type="text" name="conf_senha" className="form-control" onChange={this.handleChange.bind(this)}/>
                      <small className="form-text text-danger">{this.state.errors.confirm_password}</small>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-3 pt-5">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" id="env_senha" name="env_senha" 
                      onChange={this.handleChange.bind(this)}/> 
                      <label className="form-check-label" htmlFor="env_senha">Enviar Senha para o Usuário.</label>
                    </div>

                  </div>
                </div>
              </div>
              <header>
                Endereço
            </header>
              <div className="endereco-wrapper" >
                <div className="row">
                  <div className="col-sm-12 col-md-6 col-lg-2">
                    <div className="form-group">
                      <label htmlFor="cep" className="labelB">CEP: <span style={{ color: 'red' }}>*</span></label>
                      <MaskedInput mask="11111-111" type="text" name="cep" onBlur={this.getCep.bind(this)}
                        value={this.state.cep === null ? '' : this.state.cep}
                        className="form-control"
                        placeholder="CEP"
                        onChange={this.handleChange.bind(this)} required
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="tipo_logradouro" className="labelB">Tipo Logradouro: <span style={{ color: 'red' }}>*</span></label>
                      <select className="form-control custom-select" value={this.state.tipo_logradouro === null ? '' : this.state.tipo_logradouro}
                        name="tipo_logradouro" onChange={this.handleChange.bind(this)} required>
                        <option value="" >Selecione</option>
                        <option value="Alameda" >Alameda</option>
                        <option value="Área" >Área</option>
                        <option value="Avenida" >Avenida</option>
                        <option value="Campo" >Campo</option>
                        <option value="Chácara" >Chácara</option>
                        <option value="Colônia" >Colônia</option>
                        <option value="Condomínio" >Condomínio</option>
                        <option value="Conjunto" >Conjunto</option>
                        <option value="Distrito" >Distrito</option>
                        <option value="Esplanada" >Esplanada</option>
                        <option value="Estação" >Estação</option>
                        <option value="Estrada" >Estrada</option>
                        <option value="Favela" >Favela</option>
                        <option value="Feira" >Feira</option>
                        <option value="Jardim" >Jardim</option>
                        <option value="Ladeira" >Ladeira</option>
                        <option value="Lago" >Lago</option>
                        <option value="Lagoa" >Lagoa</option>
                        <option value="Largo" >Largo</option>
                        <option value="Loteamento" >Loteamento</option>
                        <option value="Morro" >Morro</option>
                        <option value="Núcleo" >Núcleo</option>
                        <option value="Parque" >Parque</option>
                        <option value="Passarela" >Passarela</option>
                        <option value="Pátio" >Pátio</option>
                        <option value="Praça" >Praça</option>
                        <option value="Quadra" >Quadra</option>
                        <option value="Recanto" >Recanto</option>
                        <option value="Residencial" >Residencial</option>
                        <option value="Rodovia" >Rodovia</option>
                        <option value="Rua" >Rua</option>
                        <option value="Setor" >Setor</option>
                        <option value="Sítio" >Sítio</option>
                        <option value="Travessa" >Travessa</option>
                        <option value="Trecho" >Trecho</option>
                        <option value="Trevo" >Trevo</option>
                        <option value="Vale" >Vale</option>
                        <option value="Vereda" >Vereda</option>
                        <option value="Via" >Via</option>
                        <option value="Viaduto" >Viaduto</option>
                        <option value="Viela" >Viela</option>
                        <option value="Vila" >Vila</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="logradouro" className="labelB">Logradouro: <span style={{ color: 'red' }}>*</span></label>
                      <input type="text" name="logradouro"
                        className="form-control"
                        placeholder="Logradouro" 
                        defaultValue={this.state.logradouro === null ? '' : this.state.logradouro}
                        onChange={this.handleChange.bind(this)} required
                        />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-2">
                    <div className="form-group">
                      <label htmlFor="numero" className="labelB">Nº: <span style={{ color: 'red' }}>*</span></label>
                      <input type="text" name="numero"
                        className="form-control" placeholder="Nº" 
                        defaultValue={this.state.numero === null ? '' : this.state.numero}
                        onChange={this.handleChange.bind(this)} required
                        />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="complemento" className="labelB">Complemento: <span style={{ color: 'red' }}>*</span></label>
                      <input type="text" name="complemento"
                        className="form-control"
                        placeholder="Complemento" 
                        defaultValue={this.state.complemento === null ? '' : this.state.complemento}
                        onChange={this.handleChange.bind(this)} required
                        />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="bairro" className="labelB">Bairro: <span style={{ color: 'red' }}>*</span></label>
                      <input type="text" name="bairro"
                        className="form-control"
                        placeholder="Bairro" 
                        defaultValue={this.state.bairro === null ? '' : this.state.bairro}
                        onChange={this.handleChange.bind(this)} required
                        />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="cidade" className="labelB">Cidade: <span style={{ color: 'red' }}>*</span></label>
                      <input type="text" name="cidade" defaultValue={this.state.cidade}
                        className="form-control"
                        placeholder="Cidade" 
                        onChange={this.handleChange.bind(this)} required
                        />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="uf" className="labelB">UF: <span style={{ color: 'red' }}>*</span></label>
                      <input type="text" name="uf" defaultValue={this.state.uf} required
                        className="form-control"
                        placeholder="Estado" 
                        onChange={this.handleChange.bind(this)}
                        />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="observacao-wrapper">
              <label htmlFor="observacao">Observação</label>
              <textarea name="observacao" rows="3"
                className="form-control"></textarea>
            </div>
          </div>
          <div className="modal-footer" style={{marginTop: '15px'}}>
            {closeBtn}
            <button type="submit" className="btn btn-primary" style={{marginRight:'-15px'}}><i className="fa fa-floppy-o" aria-hidden="true"></i> Salvar</button>
          </div>
        </div>
        }
      </Form>
    );
  }
}

export default FormUser